import { Outlet, createFileRoute } from '@tanstack/react-router';
import AuthContainer from '@/components/layout/AuthContainer';

export const Route = createFileRoute('/auth')({
  head: () => ({
    meta: [{ title: 'Autenticação' }],
  }),
  component: () => (
    <AuthContainer>
      <Outlet />
    </AuthContainer>
  ),
});
